
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/attentive",
      function () {
        return require("private-next-pages/destinations/attentive.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/attentive"])
      });
    }
  